import React, { useContext, useEffect, useState } from "react";
import {Button, Nav} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import DropDownLanguage from "./DropDownLanguage";
import PlayArrow from "@material-ui/icons/PlayArrow";
import axios from "axios";
import swal from "sweetalert";
import "./css/logIn.css";
import PhoneInput from "react-phone-number-input";
import HelloSuperStarLogo from "../../Assets/Images/HelloSuperStarLogo.png";
import { LocationContext } from "../../CustomHelper/Helper";
import { useTranslation } from 'react-i18next';
import {useI18n} from "../../i18n";

const Login = () => {
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    if(localStorage.removeItem("isLoggedIn") == true){}
  }, []);
  const [loading, setLoading] = useState(false);
  const [customStyle, setCustomStyle] = useState(false);

  const history = useHistory();
  const [loginInput, setLogin] = useState({
    email: "",
    password: "",
    error_list: [],
  });

  const { myLocation, regPromo, setRegPromo } = useContext(LocationContext);

  const [isPhone, setIsPhone] = useState(false);

  const [rememberMe,setRememberMe] = useState(false);

const checkRememberMe = () =>{
  rememberMe == true ? setRememberMe(false) : setRememberMe(true) 
}

  const handleInput = (e) => {
    setCustomStyle(true);

    e.persist();
    setLogin({ ...loginInput, [e.target.name]: e.target.value });
  };

  const handleInputEmail = (e) => {
    setCustomStyle(true);
    e.persist();

    const phoneNumberRegex = /(\+?\d{1,2}[\s-]?)?\(?\d{1}\)?[\s-]?\d{1}/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


    if (phoneNumberRegex.test(e.target.value) && e.target.value.length < 3) {
      setIsPhone(true)
    } else {

      setLogin({ ...loginInput, email: e.target.value });
    }


  };

  const loginSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
       // email: isPhone? "+" + loginInput.email:loginInput.email,
       email: loginInput.email,
       password: loginInput.password,
    };

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/login`, data).then((res) => {
        if (res.data.status === 200) {
          let userEmail = res.data.email != null ? res.data.email : "";
          let userMobile = res.data.phone != null ? res.data.phone : "";
          localStorage.setItem("isLoggedIn", rememberMe);
          localStorage.setItem("auth_token", res.data.token);
          localStorage.setItem("auth_name", res.data.name);
          localStorage.setItem("auth_email", userEmail);
          localStorage.setItem("auth_phone", userMobile);
          localStorage.setItem("auth_id", res.data.id);
          localStorage.setItem("auth_image", res.data?.user?.image);
          // swal("Success", res.data.message, "success");
          history.push("/");
        } else if (res.data.status === 403) {
          //swal("Success", res.data.message, "success");
          history.push("/otp");
        } else if (res.data.status === 401) {
          setLoading(false);
          if(res.data.message == "Invalid Credantials")
          {
            swal("Warning", "Invalid Credentials", "warning");
          }else{
            swal("Warning", res.data.message, "warning");
          }

        } else {
          setLoading(false);
          setLogin({ ...loginInput, error_list: res.data.validation_errors });
        }
      });
    });
  };

  const [changeIcon, setChange] = useState(false);
  function handleChangeIcon() {
    setChange(!changeIcon);
  }


  return (
    <>
      <div className="bg-img mobileLog ">
        <div className="container-fluid">
          {/*<select className="language-select rightContainer"  style={{ color: "black" }} onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>*/}
          {/*  <option  className="bg-dark" style={{ color: "#fff" }} value="en">English</option>*/}
          {/*  <option  className="bg-dark" style={{ color: "#fff" }} value="ba">Bangla</option>*/}
          {/*</select>*/}
          <div className="row d-flex align-items-center">
            <div
              className="col-md-12  mx-auto row d-flex justify-content-between align-items-center"
              style={{ minHeight: "100vh" }}
            >
              <div className="col-md-6 align-items-center ">
                <center>
                  {" "}
                  <div>
                    <img
                      src={HelloSuperStarLogo}
                      alt="Hello Super Star Logo "
                      className="MobileLogoLog"
                    />
                  </div>
                  <div>
                    <Link to="/tutorial">
                      <button className="btn mt-3 TabBtnLog px-4 Virtual">
                        <PlayArrow />
                        <span className="mx-2 ">{t('Virtual_Tour_text')}</span>
                      </button>
                    </Link>
                  </div>
                </center>
              </div>

              <div className="col-md-6 d-flex justify-content-center align-items-center ">
                <div className="wrapperLog LogBgColor pb-2">
                  <form onSubmit={loginSubmit} className="w-100">
                    <center>
                      <h4 className="fw-bold mt-2 mb-3 log-title">
                        Hello Super Stars
                      </h4>
                    </center>

                    <div class="form-group w-100">
                      <label
                        className="text-lead new_log"
                        for="exampleInputEmail1"
                      >
                        {t('Email_Phone_Number_text')}
                      </label>
                      {!isPhone ? (
                        <input
                          type="text"
                          name="email"
                          onChange={handleInputEmail}
                          value={loginInput.email}
                          className=" log_in_new py-2 px-2"
                          placeholder= {t('Email_text')}
                        />
                      ) : (
                        <PhoneInput
                          className="log_in_new "
                          value={loginInput.email}
                          country={
                            myLocation?.countryCode
                              ? myLocation.countryCode.toLowerCase()
                              : "bd"
                          }
                          // name="email"
                          onChange={(phone) =>
                            setLogin({ ...loginInput, email: phone })
                          }
                          onClick={() => {
                            setCustomStyle(true);
                          }}
                        />
                      )}

                      <small id="emailHelp" class="form-text text-danger pt-2">
                        {loginInput?.error_list?.phone}
                        {loginInput.error_list.email}
                      </small>
                    </div>

                    <div class="form-group  mt-2">
                      <label
                        className="text-lead new_log"
                        for="exampleInputPassword1"
                      >
                        {t('Password_text')}
                      </label>
                     <span className="in-eye-pas">
                     <input
                        type={changeIcon ? `text` : `password`}
                        name="password"
                        onChange={handleInput}
                        value={loginInput.password}
                        onClick={() => {
                          setCustomStyle(true);
                        }}
                        className="log_in_new py-2 px-2"
                        placeholder={t('Password_text')}
                      />
                      <span onClick={handleChangeIcon} className="eye-icons">
                        <FontAwesomeIcon
                          icon={changeIcon ? faEye : faEyeSlash}
                        />
                      </span>
                     </span>
                      <small id="emailHelp" class="form-text text-danger pt-2">
                        {loginInput.error_list.password}
                      </small>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-2 mx-3">
                      <small className="rem-text">
                        <input
                          type="checkbox"
                          name="remember"
                          onClick={checkRememberMe}
                          checked={rememberMe}
                        />
                        {t('Remember_me_text')}
                      </small>
                      <small>
                        <Link to="/forget-password" className="rem-text">
                          {t('Forgot_password_text')}
                        </Link>
                      </small>
                    </div>
                    <br />
                    {loading ? (
                      <Button className="btn BtnLogin w-100" disabled>
                        <i className="fas fa-spinner fa-pulse"></i> &nbsp;
                        {t('Loading_text')}
                      </Button>
                    ) : (
                      <Button className="btn BtnLogin w-100" type="submit">
                        {t('Log_In_text')}
                      </Button>
                    )}
                  </form>

                  <div className="d-flex mb-3 justify-content-around mb-3 mt-4 px-4 pb-0">
                    <Link
                      to="/signup"
                      className="btn btn-outline-warning BtnLoginSub px-3 mx-2 userBtn-font w-100"
                    >
                      {t('Sign_Up_text')}
                    </Link>
                    {/* <Link
                      // to="/guest_mode"
                      to="/guest_mode"
                      className="btn btn-outline-warning BtnLoginSub px-3 mx-2 userBtn-font"
                    >
                      {t('Guest_user_text')}
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="topright text-light">
          {/* about us button */}
          <Link to="/about-us" className="aboutUsBtn">
            About Us
          </Link>
          {/*<DropDownLanguage />*/}
          <select className="language-select rightContainer"  style={{ color: "black" }} onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>
            <option  className="bg-dark" style={{ color: "#fff" }} value="en">English</option>
            <option  className="bg-dark" style={{ color: "#fff" }} value="ba">Bangla</option>
          </select>
        </div>
      </div>
    </>
  );
};

export default Login;
